import { motion } from "framer-motion";
import { AI_USES } from "@/data/site";
import { MaskedLines, SectionTag } from "@/components/Kinetic";
import { EASE, viewport } from "@/lib/motion";

export const AIWorkflow = () => (
  <section
    data-testid="ai-workflow"
    className="relative border-t border-[#1f1f1f] bg-[#0d0d0d] py-20 md:py-28"
  >
    <div className="mx-auto max-w-[1700px] px-5 md:px-10">
      <SectionTag num="06 / WORKFLOW">AI-ASSISTED PRODUCTION</SectionTag>

      <div className="grid gap-12 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-5">
          <MaskedLines
            lines={["MORE ITERATIONS.", "LESS WAITING."]}
            className="font-display text-3xl font-black uppercase leading-[0.9] tracking-[-0.04em] text-[#e5e5e5] md:text-[3.2vw]"
            testId="ai-headline"
          />
          <p className="mt-8 max-w-md text-sm leading-relaxed text-[#a3a3a3] md:text-base">
            AI accelerates the workflow. It doesn't create the work. Ideas get
            explored faster and options get tested earlier — the cut, the taste
            and the final call stay human.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-x-3 gap-y-2 border-y border-[#1f1f1f] py-6">
            <span className="label text-[#e5e5e5]">HUMAN CREATIVE DIRECTION</span>
            <span className="label text-[#d4ff00]">+</span>
            <span className="label text-[#e5e5e5]">EDITING</span>
            <span className="label text-[#d4ff00]">+</span>
            <span className="label text-[#a3a3a3]">AI-ASSISTED PRODUCTION</span>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="border-t border-[#1f1f1f]">
            {AI_USES.map((s, i) => (
              <motion.div
                key={s.k}
                initial={{ opacity: 0, x: -14 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={viewport}
                transition={{ duration: 0.6, ease: EASE, delay: i * 0.06 }}
                className="grid grid-cols-12 items-baseline gap-4 border-b border-[#1f1f1f] py-5"
              >
                <span className="col-span-12 label text-[#d4ff00] md:col-span-4">
                  {s.k}
                </span>
                <span className="col-span-12 text-sm text-[#a3a3a3] md:col-span-8">
                  {s.v}
                </span>
              </motion.div>
            ))}
          </div>
          <p className="mt-6 max-w-lg text-sm leading-relaxed text-[#7a7a7a]">
            Nothing here replaces an editing decision. It removes the wait
            between having an idea and being able to look at it.
          </p>
        </div>
      </div>
    </div>
  </section>
);
